import MDAccordionSimple from "components/MDAccordion/MDAccordionSimple";
import MDAccordionTable from "components/MDAccordion/MDAccordionTable";
import { NumericFormat } from "react-number-format";
import DataTable from "examples/Tables/DataTable";
import CloseIcon from "@mui/icons-material/Close";
import MuiAlert from "@mui/material/Alert";
import OrderService from "services/OrderService";
import PaymentConditionService from "services/PaymentConditionService";
import PaymentFormService from "services/PaymentFormService";
import AdditionalExpTypeService from "services/AdditionalExpTypeService";
import AttachmentService from "services/AttachmentService";
import TaxTypeService from "services/TaxTypeService";
import React, { useEffect, useState, useCallback } from "react";
import MDTypography from "components/MDTypography";
import { Modal, Snackbar, Alert } from "@mui/material";
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import Grid from "@mui/material/Grid";
import { useNavigate, useLocation } from "react-router-dom";
import TextField from "@mui/material/TextField";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { parseISO, format, set } from "date-fns";
import LoadingComponent from "assets/theme/functions/loadingAnimation";
import { useAuth } from "context/authContext";
import ShippingTypeService from "services/ShippingTypeService";
import OrderHeader from "layouts/quotations/QuotationHeader";

const isUnauthorizedError = (error) => error?.response?.status === 401;

const OrderDetails = (id, password) => {
  const [open, setOpen] = useState(false);
  const { token, user, isAuthenticated } = useAuth();
  const [order, setOrder] = useState();
  const [updatedOrder, setUpdatedOrder] = useState({ OrderLines: [] });
  const [expenseTypes, setExpenseTypes] = useState([]);
  const [selectedItemTax, setSelectedItemTax] = useState({});
  const [selectedTaxItems, setSelectedTaxItems] = useState([]);
  const [editedTaxItems, setEditedTaxItems] = useState([]);
  const [footerValues, setFooterValues] = useState({ TotalBefDiscount: '', FinanceDiscount: '', OtherCostsSum: 0, Rounding: 0, TaxSum: 0, DocTotal: 0, });
  const [taxTypes, setTaxTypes] = useState([]);
  const [shippingTypesList, setShippingTypesList] = useState([{}]);
  const [paymentFormsList, setPaymentFormsList] = useState([{}]);
  const [modalOpen, setModalOpen] = useState(false);
  const [attachments, setAttachments] = useState([]);
  const [loadingAttachments, setLoadingAttachments] = useState(false);
  const [paymentConditionsList, setPaymentConditionsList] = useState([{}]);
  const [loadingMessage, setLoadingMessage] = useState({ error: false, message: "" });
  const [showLogo, setShowLogo] = useState(true);
  const [snackbar, setSnackbar] = useState({ open: false, message: "", severity: "error" });
  const { state } = useLocation();

  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpen(false);
  };

  const navigate = useNavigate();

  const attachmentItems = () => {
    if (loadingAttachments) {
      return [{
        OriginalName: "Carregando...",
        Size: "...",
        Description: "...",
        Baixar: "Carregando..."
      }];
    }

    if (!attachments || attachments.length === 0) {
      return [{
        OriginalName: "Nenhum anexo encontrado",
        Size: "-",
        Description: "-",
        Baixar: "-"
      }];
    }

    return attachments.map((attachment, index) => ({
      OriginalName: attachment.OriginalName || "Nome não disponível",
      Size: attachment.Size ? `${(attachment.Size / 1024).toFixed(2)} KB` : "Tamanho não disponível",
      Description: attachment.Description || "Sem descrição",
      Baixar: "Download",
      _originalData: attachment,
      _index: index
    }));
  };

  const handleDownloadAttachment = async (attachment) => {
    try {
      await AttachmentService.downloadAttachment(attachment.Url, attachment.OriginalName, token);

    } catch (error) {
      console.error("Erro ao baixar anexo:", error);
    }
  };

  const handleCloseSnackbar = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setSnackbar({ ...snackbar, open: false });
  };

  const handleItemChange = useCallback(
    (index, field, value) => {
      setOrder((prev) => {
        const updatedOrderLines = [...prev.OrderLines];
        updatedOrderLines[index] = {
          ...updatedOrderLines[index],
          [field]: value,
        };

        const currentLine = updatedOrderLines[index];

        setUpdatedOrder((prevUpdated) => {
          const orderLines = prevUpdated?.OrderLines || [];

          const existingIndex = orderLines.findIndex(
            line => line.Id === currentLine.Id
          );

          if (existingIndex >= 0) {
            // Atualiza linha existente
            const updatedLines = [...orderLines];

            updatedLines[existingIndex] = {
              ...updatedLines[existingIndex],
              [field]: value,
            };

            return {
              ...prevUpdated,
              OrderLines: updatedLines,
            };
          }

          // Adiciona nova linha
          return {
            ...prevUpdated,
            OrderLines: [
              ...orderLines,
              {
                Id: currentLine.Id,
                [field]: value,
              },
            ],
          };
        });

        return {
          ...prev,
          OrderLines: updatedOrderLines
        }
      });
    },
    []
  );

  const handleAttachmentButtonClick = useCallback((index, fieldName, value, rowData) => {
    if (fieldName === 'Baixar') {
      // Obter os dados atuais dos attachmentItems
      const currentAttachmentItems = attachmentItems();

      // Verificar se é um item de placeholder (loading ou empty)
      const currentItem = currentAttachmentItems[index];
      if (!currentItem || !currentItem._originalData) {
        return;
      }

      // Usar os dados do _originalData
      const attachment = currentItem._originalData;

      if (attachment && attachment.OriginalName && attachment.Url) {
        handleDownloadAttachment(attachment);
      } else {
        console.error("❌ Dados do anexo incompletos:", attachment);
      }
    }
  }, [attachmentItems, handleDownloadAttachment]); // Mudança: usar attachmentItems como dependência

  const taxModalFields = {
    columns: [
      { Header: "Imposto", accessor: "Description", align: "center" },
      {
        Header: "Alíquota",
        accessor: "TaxRate",
        align: "center",
        Cell: ({ row: { index }, value }) => (
          <TextField
            value={value}
            variant="outlined"
            size="small"
            disabled={true}
            type="number"
            style={{ width: "100%", textAlign: "center", color: "#0a0a0a" }}
            InputProps={{
              inputProps: { min: 0, max: 100, step: 0.01 },
              endAdornment: " %",
            }}
          />
        ),
      },
      {
        Header: "Base de Cálculo",
        accessor: "TaxBasePercent",
        align: "center",
        Cell: ({ row: { index }, value }) => (
          <TextField
            value={value}
            variant="outlined"
            size="small"
            disabled={true}
            type="number"
            style={{ width: "100%", textAlign: "center", color: "#0a0a0a" }}
            InputProps={{
              inputProps: { min: 0, max: 100, step: 0.01 },
              endAdornment: " %",
            }}
          />
        ),
      },
      {
        Header: "Base Isenta",
        accessor: "TaxBaseFree",
        align: "center",
        Cell: ({ row: { index }, value }) => (
          <TextField
            value={value}
            disabled={true}
            variant="outlined"
            size="small"
            type="number"
            style={{ width: "100%", textAlign: "center", color: "#0a0a0a" }}
            InputProps={{
              inputProps: { min: 0, max: 100, step: 0.01 },
              endAdornment: " %",
            }}
          />
        ),
      },
      {
        Header: "Base Outros",
        accessor: "TaxBaseOthers",
        align: "center",
        Cell: ({ row: { index }, value }) => (
          <TextField
            value={value}
            variant="outlined"
            disabled={true}
            size="small"
            type="number"
            style={{ width: "100%", textAlign: "center" }}
            InputProps={{
              inputProps: { min: 0, max: 100, step: 0.01 },
              endAdornment: " %",
            }}
          />
        ),
      },
      {
        Header: "Valor",
        accessor: "TaxSum",
        align: "center",
        type: "currency",
        Cell: ({ value }) => (
          <NumericFormat
            value={value}
            displayType={"text"}
            disabled={true}
            thousandSeparator={"."}
            decimalSeparator={","}
            prefix={"R$ "}
            decimalScale={2}
            fixedDecimalScale
          />
        ),
      },
    ],
  };

  const formFields = {
    Order: [
      //{ label: "ID", name: "Id", width: 2, editable: false, type: "text" },
      {
        label: "ID Externo",
        name: "ExternalId",
        width: 2,
        editable: false,
        type: "text",
      },
      {
        label: "ID Interno",
        name: "InternalId",
        width: 2,
        editable: true,
        type: "text",
        forceNumber: true,
      },
      {
        label: "Nº Proposta/Orçamento",
        name: "RefNumber",
        width: 2,
        editable: false,
        type: "text",
      },
      {
        label: "Data do Pedido",
        name: "DocDate",
        width: 2,
        editable: false,
        type: "date",
      },
      {
        label: "Data de Entrega",
        name: "DeliveryExpectedDate",
        width: 2,
        editable: false,
        type: "date",
      },
    ],
    Buyer: [
      {
        label: "Razão Social",
        name: "BranchName",
        width: 1,
        editable: false,
        type: "text",
      },
      {
        label: "CNPJ",
        name: "BranchTaxId",
        width: 1,
        editable: false,
        type: "text",
      },
      {
        label: "Nome",
        name: "CompanyName",
        width: 2,
        editable: false,
        type: "text",
      },
      {
        label: "Telefone",
        name: "BuyerPhone",
        width: 1,
        editable: false,
        type: "text",
      },
      {
        label: "E-mail ",
        name: "BuyerEmail",
        width: 1,
        editable: false,
        type: "text",
      },
    ],
    Supplier: [
      {
        label: "Empresa",
        name: "SupplierCompanyName",
        width: 2,
        editable: false,
        type: "text",
      },
      {
        label: "CNPJ",
        name: "SupplierTaxId",
        width: 1,
        editable: false,
        type: "text",
      },
      {
        label: "Nome",
        name: "SupplierSalesperson",
        width: 1,
        editable: false,
        type: "text",
      },
      // {
      //   label: "Status",
      //   name: "Status",
      //   width: 2,
      //   editable: false,
      //   type: "combo",
      // },
      {
        label: "Confirmado",
        name: "Status",
        width: 2,
        criteriumDisable: ['P', 'E', 'C'],
        editable: false,
        type: "select",
        options: [],
      },
    ],
    attachFields: [
      {
        label: "Nome do Arquivo",
        name: "OriginalName",
        width: 4,
        editable: false,
        type: "text",
      },
      {
        label: "Descrição",
        name: "Description",
        width: 6,
        editable: false,
        type: "text",
      },
      {
        label: "Tamanho",
        name: "Size",
        width: 2,
        editable: false,
        type: "text",
      },
      {
        label: "",
        name: "Baixar",
        width: 2,
        editable: false,
        type: "button",
        disabled: !attachments || attachments.length === 0, // Desabilita quando não há anexos
      },
    ],
    addressFields: [
      {
        label: "Rua",
        name: "DeliveryAddressStreet",
        width: 5,
        editable: false,
        type: "text",
      },
      {
        label: "Nº",
        name: "DeliveryAddressNum",
        width: 3,
        editable: false,
        type: "text",
      },
      {
        label: "Bairro",
        name: "DeliveryAddressBlock",
        width: 3,
        editable: false,
        type: "text",
      },
      {
        label: "CEP",
        name: "DeliveryAddressZip",
        width: 3,
        editable: false,
        type: "text",
      },
      {
        label: "Município",
        name: "DeliveryAddressCity",
        width: 3,
        editable: false,
        type: "text",
      },
      {
        label: "Estado",
        name: "DeliveryAddressState",
        width: 3,
        editable: false,
        type: "text",
      },
    ],
    itemsFields: [
      {
        label: "Código do item",
        name: "ExtItemCode",
        width: 100,
        editable: false,
        type: "text",
      },
      {
        label: "Descrição do item",
        name: "ItemName",
        width: 100,
        editable: false,
        type: "text",
        longField: true,
      },
      {
        label: "Descrição adicional",
        name: "ItemForeignName",
        width: 10,
        editable: false,
        type: "text",
        longField: true,
      },

      {
        label: "Texto livre",
        name: "LineRemarks",
        width: 10,
        editable: false,
        type: "text",
        longField: true,
        inputProps: {
          style: {
            overflow: "auto",   // ativa a rolagem
          }
        },
      },
      {
        label: "Quantidade",
        name: "Quantity",
        width: 100,
        editable: false,
        type: "number",
      },
      {
        label: "Data Necessária",
        name: "NecessaryDate",
        width: 100,
        editable: false,
        type: "date",
      },
      {
        label: "Previsão de Entrega",
        name: "ExpectedDeliveryDate",
        width: 100,
        editable: false,
        type: "date",
      },
      {
        label: "Nova Previsão de Entrega",
        name: "NewExpectedDeliveryDate",
        width: 100,
        editable: true,
        type: "date",
      },
      {
        label: "Valor unitário",
        name: "UnitPrice",
        width: 100,
        editable: false,
        type: "currency",
      },
      {
        label: "NCM",
        name: "NcmCode",
        width: 2,
        editable: false,
        type: "text",
        longField: false,
      },
      {
        label: "Unidade de Medida",
        name: "UnitOfMeasurement",
        width: 2,
        editable: false,
        type: "text",
      },
      {
        label: "Desconto (%)",
        name: "DiscountPercent",
        width: 100,
        editable: false,
        type: "number",
      },
      {
        label: "Valor de desconto",
        name: "DiscountValue",
        width: 100,
        editable: false,
        type: "currency",
      },
      {
        label: "Utilização",
        name: "Usage",
        width: 3,
        editable: false,
        type: "text",
      },
      {
        label: "Total dos itens",
        name: "LineTotal",
        width: 3,
        editable: false,
        type: "currency",
      },
      {
        label: "Total Impostos Adicionais",
        name: "LineTaxOutPriceTotal",
        width: 3,
        editable: false,
        type: "currency",
      },
      {
        label: "Total da linha",
        name: "LineWithTaxTotal",
        width: 3,
        editable: false,
        type: "currency",
      },
      {
        label: "",
        name: "Impostos",
        width: 3,
        editable: false,
        type: "button",
      },
    ],
    paymentFields: [
      {
        label: "Forma de Pagamento",
        name: "PaymentFormId",
        width: 2,
        editable: false,
        type: "select",
        options: paymentFormsList,
      },
      {
        label: "Condição de Pagamento",
        name: "PaymentConditionId",
        width: 2,
        editable: false,
        type: "select",
        options: paymentConditionsList,
      },
    ],
    additionalExpensesFields: [
      {
        label: "Tipo de despesa",
        name: "Description",
        editable: false,
        type: "text",
      },
      {
        label: "Valor",
        name: "Value",
        width: 1,
        editable: false,
        type: "currency",
      },
    ],
    deliveryAddressFields: [
      {
        label: "Rua",
        name: "DeliveryAddressStreet",
        width: 2,
        editable: false,
        type: "text",
      },
      {
        label: "Nº",
        name: "DeliveryAddressNum",
        width: 0.75,
        editable: false,
        type: "text",
      },
      {
        label: "Bairro",
        name: "DeliveryAddressBlock",
        width: 1,
        editable: false,
        type: "text",
      },
      {
        label: "CEP",
        name: "DeliveryAddressZip",
        width: 1,
        editable: false,
        type: "text",
      },
      {
        label: "Município",
        name: "DeliveryAddressCity",
        width: 1,
        editable: false,
        type: "text",
      },
      {
        label: "Estado",
        name: "DeliveryAddressState",
        width: 1,
        editable: false,
        type: "text",
      },
      {
        label: "Complemento",
        name: "DeliveryAddressBuilding",
        width: 2,
        editable: false,
        type: "text",
        multiLine: { multiline: true, maxLength: 255 },
      },
      {
        label: "Tipo de Envio",
        name: "ShippingTypeName",
        width: 2,
        editable: false,
        type: "text",
        //type: "select",
        //options: shippingTypesList,
      },
    ],
    observationsFields: [
      { label: "Observações", name: "Comments", width: 100, editable: false, type: "text", multiLine: { multiline: true, maxLength: 255 } },
      { label: "Observações do Fornecedor", name: "SupplierComments", width: 100, editable: false, type: "text", multiLine: { multiline: true, maxLength: 255 } },
      { label: "Observações de Abertura", name: "Header", width: 100, editable: false, type: "text", multiLine: { multiline: true } },
      { label: "Observações de Encerramento", name: "Footer", width: 100, editable: false, type: "text", multiLine: { multiline: true } },
    ],

    footerFields: [
      { label: "Total dos produtos/serviços", name: "TotalBefDiscount", width: 2, editable: false, type: "currency" },
      { label: "Desconto financeiro", name: "FinanceDiscount", width: 2, editable: false, type: "currency" },
      { label: "Despesas Adicionais", name: "OtherCostsSum", width: 2, editable: false, type: "currency" },
      { label: "Impostos Adicionais", name: "TaxSum", width: 2, editable: false, type: "currency" },
      { label: "Valor Total", name: "DocTotal", width: 2, editable: false, type: "currency" },
    ],
  }

  const statusField = formFields.Supplier.find(
    field => field.name === "Status"
  );

  statusField.options =
    ['P', 'E', 'C'].includes(order?.Status)
      ? [
        { Id: "P", Description: "Entrega Pendente" },
        { Id: "E", Description: "Encerrado" },
        { Id: "C", Description: "Cancelado" },
      ]
      : [
        { Id: "A", Description: "Não" },
        { Id: "O", Description: "Sim" },
      ];

  /* 
   const billingAddressFields = [
      {
        label: "Rua",
        name: "BillingAddressStreet",
        width: 2,
        editable: false,
        type: "text",
      },
      {
        label: "Nº",
        name: "BillingAddressNum",
        width: 0.75,
        editable: false,
        type: "text",
      },
      {
        label: "Bairro",
        name: "BillingAddressBlock",
        width: 1,
        editable: false,
        type: "text",
      },
      {
        label: "CEP",
        name: "BillingAddressZip",
        width: 1,
        editable: false,
        type: "text",
      },
      {
        label: "Município",
        name: "BillingAddressCity",
        width: 1,
        editable: false,
        type: "text",
      },
      {
        label: "Estado",
        name: "BillingAddressState",
        width: 1,
        editable: false,
        type: "text",
      }
    ]
  
  */

  const removeUnnecessaryProperties = () => {
    let orderAux = {
      ...order
    };
    delete orderAux.Id;
    delete orderAux.Guid;
    delete orderAux.FreightCost;
    delete orderAux.Password;
    delete orderAux.createdAt;
    delete orderAux.updatedAt;
    delete orderAux.deletedAt;
    delete orderAux.PaymentCondition;
    delete orderAux.PaymentForm;
    orderAux.OrderLines = order.OrderLines.map((line) => {
      line.OrderLineTax = line.OrderLineTax.map((lineTax) => {
        delete lineTax.LineId;
        delete lineTax.TaxBaseFree;
        delete lineTax.TaxBaseOthers;
        return lineTax;
      });
      delete line.Id;
      delete line.TennantId;
      delete line.OrderId;
      delete line.QuotationId;
      delete line.QuotationLineId;
      delete line.QuotationId;
      delete line.QuotationLineId;
      return line;
    });
    delete orderAux.AdditionalExpenses;
    return orderAux;
  };

  // const handleItemChange = useCallback(
  //   (index, field, value) => {
  //     setOrder((prev) => {
  //       const updatedOrderLines = [...prev.OrderLines];
  //       const updatedLine = { ...updatedOrderLines[index] };
  //       updatedLine[field] = value;
  //       updatedOrderLines[index] = updatedLine;
  //       return { ...prev, OrderLines: updatedOrderLines };
  //     });
  //   }, 
  //   []
  // );

  useEffect(() => {
    try {
      const handleScroll = () => {
        setShowLogo(window.scrollY === 0);
      };

      window.addEventListener("scroll", handleScroll);

      return () => {
        window.removeEventListener("scroll", handleScroll);
      };
    }
    catch (error) {

    }
  })

  useEffect(() => {

    const init = async () => {
      const authenticated = await isAuthenticated();
      if (!password && !authenticated) {
        navigate(`/access-order/${id}`);
        return;
      }

      if (Number(state?.id) === 1) {
        setSnackbar({
          open: true,
          message: state.error,
          severity: "error",
        })
      }

      fetchData();
    };

    const fetchData = async () => {
      try {
        let response = await OrderService.getOrders(id, password);
        const orderData = response.data.data[0];
        if (!orderData) {
          setLoadingMessage({ error: true, message: "Não foi possível carregar a página: nenhuma ordem foi encontrada." });
        }

        if (!password && orderData?.UserEmail !== user?.Email) {
          navigate('/login');
          return;
        }
        // Converter campos de data
        formFields.Order.forEach((field) => {
          if (field.type === "date" && orderData[field.name]) {
            orderData[field.name] = format(
              parseISO(orderData[field.name]),
              "yyyy-MM-dd"
            );
          }
        });
        orderData.OrderLines = orderData.OrderLines.map((line) => {
          formFields.itemsFields.forEach((field) => {
            if (field.type === "date" && line[field.name]) {
              line[field.name] = format(
                parseISO(line[field.name]),
                "yyyy-MM-dd"
              );
            }
          });
          return line; // Retorna a linha formatada
        });

        let tennantId = orderData.TennantId;

        const [
          paymentConditionsResponse,
          paymentFormResponse,
          expenseTypesResponse,
          taxTypeResponse,
          shippingTypeResponse,
          attachmentResponse,
        ] = await Promise.all([
          PaymentConditionService.GetPaymentConditions(tennantId),
          PaymentFormService.GetPaymentForms(tennantId),
          AdditionalExpTypeService.GetAdditionalExpenseTypes(tennantId),
          TaxTypeService.GetTaxTypes(tennantId),
          ShippingTypeService.GetShippingTypes(tennantId),
          AttachmentService.getOrderAttachments(orderData.Guid, orderData.TennantId)
        ]);

        if (expenseTypesResponse?.data?.data?.length === 0) {
          setLoadingMessage({ error: true, message: "Não foi possível carregar a página: tipos de despesa não foram encontrados." });
          return;
        }

        if (paymentConditionsResponse?.data?.data?.length === 0) {
          setLoadingMessage({ error: true, message: "Não foi possível carregar a página: condições de pagamento não foram encontradas." });
          return;
        }

        if (paymentFormResponse?.data?.data?.length === 0) {
          setLoadingMessage({ error: true, message: "Não foi possível carregar a página: formas de pagamento não foram encontradas." });
          return;
        }

        if (taxTypeResponse?.data?.data?.length === 0) {
          setLoadingMessage({ error: true, message: "Não foi possível carregar a página: tipos de imposto não foram encontrados." });
          return;
        }

        if (shippingTypeResponse?.data?.data?.length === 0) {
          setLoadingMessage({ error: true, message: "Não foi possível carregar a página: tipos de frete não foram encontrados." });
          return;
        }

        // setShippingTypesList(
        //   shippingTypeResponse.data.data.map(({ Id, ExtDescription }) => ({
        //     Id: Number(Id),
        //     Description: ExtDescription,
        //   }))
        // );
        setOrder({
          ...orderData,
          CompanyName: orderData?.Tennant?.CompanyName,
          SupplierCompanyName: orderData?.Supplier?.CompanyName,
          Base64Logo: orderData?.Tennant?.Base64Logo ?? "",
          TennantId: orderData?.Tennant?.Id,
          OrderLines: orderData.OrderLines.map((line) => ({
            ...line,
            OrderLineTax: line.OrderLineTax.map((tax) => ({
              ...tax,
              TaxInPrice: !!taxTypeResponse.data.data.find((t) => t.Id === tax.TaxTypeId)?.TaxInPrice,
            })),
          })),
          ShippingTypeName: shippingTypeResponse.data.data?.find(x => Number(x.Id) === Number(orderData?.ShippingTypeId))?.ExtDescription ?? "",
          SupplierSalesperson: user?.Name,
          SupplierTaxId: orderData?.Supplier?.TaxId,
        });
        setAttachments(attachmentResponse.data.data);
        setExpenseTypes(expenseTypesResponse.data.data);
        setTaxTypes(taxTypeResponse.data.data);
        //console.log("01", paymentConditionsResponse.data.data);

        setPaymentConditionsList(
          paymentConditionsResponse.data.data.map(({ Id, ExtDescription }) => ({
            Id: Number(Id),
            Description: ExtDescription,
          }))
        );
        //console.log("02", paymentFormResponse.data.data);

        setPaymentFormsList(
          paymentFormResponse.data.data.map(({ Id, ExtDescription }) => ({
            Id: Number(Id),
            Description: ExtDescription,
          }))
        );

        const costs = orderData.AdditionalExpenses.reduce((cost, line) => cost + (Number(line.Value) || 0), 0);
        const discount = orderData.FinanceDiscount;
        setFooterValues((footerValues) => ({
          ...footerValues,
          DocTotal: orderData.DocTotal,
          TaxSum: orderData.OrderLines.reduce((tax, line) => tax + (Number(line.LineTaxOutPriceTotal) || 0), 0),
          OtherCostsSum: costs,
          TotalBefDiscount: orderData.OrderLines.reduce((total, line) => total + (Number(line.LineTotal) || 0), 0),
          FinanceDiscount: discount,
        }));

      } catch (error) {
        if (!isUnauthorizedError(error)) {
          console.error("Ocorreu um erro ao buscar o pedido!", error);
        }
      }
    };

    init();

  }, [id, navigate, user]);

  if (!order) {
    return (
      <LoadingComponent {...loadingMessage} />
    );
  }

  const renderAdditionalExpenses = () => {
    let teste = expenseTypes.map((type, index) => {
      const existingExpense = order.AdditionalExpenses?.find(
        (expense) => String(expense.ExpenseTypeId) === String(type.Id)
      ) || { Value: 0 };
      return {
        Description: type.Description,
        Value: parseFloat(existingExpense.Value) || 0,
      };
    });
    return teste;
  };
  const renderLines = () => {
    return order.OrderLines.map((line) => {

      const DiscountValue = (line.Quantity * line.UnitPrice * line.DiscountPercent) / 100;
      const LineSum = line.Quantity * line.UnitPrice;
      const LineTotal = LineSum - DiscountValue;

      const TaxOutSum = line?.OrderLineTax.reduce(
        (tax, line) => {
          const taxBasePercent = parseFloat(line.TaxBasePercent) || 100;
          //console.log("02", taxBasePercent)
          const taxRate = parseFloat(line.TaxRate) || 0;
          //console.log("03", taxRate)

          let taxSum = (LineTotal * (taxBasePercent / 100) * taxRate) / 100;
          //console.log("04", taxSum)

          taxSum = isNaN(taxSum) ? 0 : parseFloat(taxSum.toFixed(2));

          return tax + (
            line.TaxInPrice
              ? 0
              : (taxSum || 0)
          )
        },
        0);

      line.DiscountValue = DiscountValue;
      line.LineTotal = LineTotal;
      line.LineTaxOutPriceTotal = TaxOutSum;
      line.LineWithTaxTotal = LineTotal + TaxOutSum;

      const taxes = line.OrderLineTax.reduce((acc, tax) => {
        const taxType = taxTypes.find((t) => t.Id === tax.TaxTypeId);
        if (taxType) {
          acc[taxType.Description] = tax.TaxRate; // Usa a descrição como chave e taxa como valor
        }
        return acc;
      }, {});

      return {
        ...line,
        ...taxes, // Adiciona as propriedades dinamicamente ao objeto line
      };
    });
  };

  const buildTaxModalData = (lineIndex) => {
    const modalTaxData = order.OrderLines.flatMap((line) => {
      const taxTypesMap = (line.OrderLineTax || []).map((existingTax) => {
        const taxType = taxTypes.find((t) => String(t.Id) === String(existingTax.TaxTypeId));

        return {
          Id: existingTax.Id,
          LineId: line.Id,
          TaxTypeId: existingTax.TaxTypeId,
          Description: taxType?.Description || `Imposto ${existingTax.TaxTypeId}`,
          TaxBasePercent: existingTax.TaxBasePercent || 100,
          TaxRate: existingTax.TaxRate || 0,
          TaxBaseFree: existingTax.TaxBaseFree || 0,
          TaxBaseOthers: existingTax.TaxBaseOthers || 0,
          TaxInPrice: existingTax.TaxInPrice || true,
          TaxSum: existingTax.TaxSum || 0,
        };
      });

      return taxTypesMap.filter((tax) => Number(tax.TaxRate) > 0);
    });

    setSelectedItemTax({
      ItemCode: order.OrderLines[lineIndex]?.ExtItemCode,
      ItemName: order.OrderLines[lineIndex]?.ItemName,
    });

    const filteredTaxes = modalTaxData.filter(
      (tax) => String(tax.LineId) === String(order.OrderLines[lineIndex]?.Id)
    );

    setSelectedTaxItems(filteredTaxes);
    setEditedTaxItems(filteredTaxes);
    setModalOpen(true);
  };

  const handleInputChange = (name, value) => {
    setOrder((prev) => ({
      ...prev,
      [name]: value,
    }));
    setUpdatedOrder((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleUpdate = async () => {
    // lógica de atualização
    //console.log('order', order);
    try {
      await OrderService.editSpecificFieldsOrders(order.Guid, updatedOrder, token)
        .then(() => {
          setOpen(true);
        })
        .catch((error) => {
          console.error("Ocorreu um erro ao atualizar o pedido!", error);
        });
      await OrderService.editOrderStatus(order.Guid, { Status: order.Status, IntegrationStatus: "P" }, token)
        .then(() => {
          setOpen(true);
        })
        .catch((error) => {
          console.error("Ocorreu um erro ao atualizar o pedido!", error);
        });
    }
    catch (error) {
      console.error("Ocorreu um erro ao atualizar o pedido!", error);
    }
  };

  const handleModalClose = () => {
    setModalOpen(false);
  };

  const renderFooterValues = () => {
    let totalBefDiscount = order.OrderLines.reduce((tax, line) => tax + (Number(line.LineTotal) || 0), 0);
    let taxSum = order.OrderLines.reduce((tax, line) => tax + (Number(line.LineTaxOutPriceTotal) || 0), 0)
    return {
      ...footerValues,
      FinanceDiscount: order.FinanceDiscount,
      TaxSum: taxSum,
      TotalBefDiscount: totalBefDiscount,
      DocTotal: totalBefDiscount + footerValues.OtherCostsSum + taxSum - footerValues.FinanceDiscount,
    }
  }

  /* const renderFields = (field) => {
    switch (field.type) {
      case "date":
        return (
          <TextField
            fullWidth
            size="small"
            variant="outlined"
            value={
              order[field.name]
                ? format(parseISO(order[field.name]), "dd/MM/yyyy")
                : null
            }
            InputProps={{
              readOnly: !field.editable,
            }}
            sx={{
              mt: 0.5,
              "& .MuiOutlinedInput-root": {
                backgroundColor: field.editable ? "inherit" : "#f0f0f0",
                "& fieldset": { borderColor: "rgba(0, 0, 0, 0.12)" },
              },
            }}
          />
        );
      case "combo":
        return (
          <select
            name={field.name}
            value={order[field.name]}
            onChange={(e) => handleInputChange(e)}
            disabled={['P', 'E', 'C', 'O'].includes(order[field.name])}
            style={{
              fontFamily: '"Roboto", "Helvetica", "Arial", "sans-serif"',
              fontSize: "0.75rem",
              fontWeight: "400",
              lineHeight: "1.4375em",
              letterSpacing: "0.00938em",
              borderColor: "rgb(197 197 197)",
              boxSizing: "border-box",
              display: "inline-flex",
              alignItems: "center",
              width: "100%",
              position: "relative",
              borderRadius: "4px",
              backgroundColor: "transparent",
              borderRadius: "0.375rem",
              height: "37px",
              marginTop: "3px",
              color: "#495057",
              padding: "0.5rem",
            }}
          >
            {optionsForCombo.map((option, index) => (
              <option key={index} value={option.id}>
                {option.label}
              </option>
            ))}
          </select>
        );
      case "text":
        return (
          <TextField
            fullWidth
            name={field.name}
            value={order[field.name] || ""}
            variant="outlined"
            size="small"
            type={field.type}
            InputProps={{ readOnly: !field.editable }}
            sx={{
              mt: 0.5,
              "& .MuiOutlinedInput-root": {
                backgroundColor: field.editable ? "inherit" : "#f0f0f0",
                "& fieldset": { borderColor: "rgba(0, 0, 0, 0.12)" },
              },
            }}
          />
        );
      default:
        return null;
    }
  }; */

  /* const headerDetails = (
    <MDBox p={3}>
      <LocalizationProvider dateAdapter={AdapterDateFns}>
        <Grid container spacing={2}>
          {headerFormFields.map((field) => (
            <Grid item xs={12} sm={12} md={12} lg={3} key={field.name}>
              <MDBox mb={1} fullWidth>
                <MDTypography
                  variant="caption"
                  fontWeight="medium"
                  color="text"
                  textTransform="uppercase"
                >
                  {field.label}
                </MDTypography>
                {renderFields(field)}
              </MDBox>
            </Grid>
          ))}
        </Grid>
      </LocalizationProvider>
    </MDBox>
  ); */

  const snackBar = (
    <Snackbar
      open={open}
      autoHideDuration={4000}
      onClose={handleClose}
      anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
    >
      <MuiAlert onClose={handleClose} severity="success" sx={{ width: "100%" }}>
        Pedido atualizado com sucesso!
      </MuiAlert>
    </Snackbar>
  );

  return (
    <>
      {showLogo && (
        <MDBox
          component="img"
          src={order.Base64Logo}
          //backgroundColor="blue"
          onClick={() => {
            navigate(`/landing-page`, {
              state: {
                tenantId: order?.TennantId,
                basePath: window.location.pathname,
              },
            })
          }
          }
          sx={{
            maxWidth: 240,
            maxHeight: 81,
            top: 20,
            position: "fixed",
            right: 50,
            cursor: "pointer",
            zIndex: 9999,
          }}
        />
      )}
      <MDBox>
        <MDAccordionSimple
          color="info"
          title="Proposta"
          //fields={[formFields.deliveryAddress, formFields.billingAddress]}
          //nestedTitle={["Endereço de Entrega", "Endereço de Cobrança"]}
          fields={[formFields.Order, formFields.Buyer, formFields.Supplier]}
          nestedTitle={["", "Dados Comprador", "Seus Dados"]}
          data={order}
          handleInputChange={handleInputChange}
        />
        {/* headerDetails */}
        <MDBox mt={4}>
          <MDAccordionSimple
            color="info"
            title="Logística"
            //fields={[deliveryAddressFields, billingAddressFields]}
            //nestedTitle={["Endereço de Entrega", "Endereço de Cobrança"]}
            fields={[formFields.deliveryAddressFields]}
            nestedTitle={["Endereço de Entrega"]}
            data={order}
          />
          <MDAccordionTable
            color="info"
            title="Itens"
            fields={formFields.itemsFields}
            items={renderLines()}
            handleInputChange={handleItemChange}
            handleButtonClick={(lineIndex) => buildTaxModalData(lineIndex)}
          />
          <MDAccordionSimple
            color="info"
            title="Pagamento"
            fields={formFields.paymentFields}
            data={order}
          />
          <MDAccordionSimple
            color="info"
            title="Observações"
            fields={formFields.observationsFields}
            data={order}
          />
          <MDAccordionTable
            color="info"
            title="Despesas Adicionais"
            fields={formFields.additionalExpensesFields}
            items={renderAdditionalExpenses()}
          />
          <MDAccordionTable
            color="info"
            title="Anexos"
            fields={formFields.attachFields}
            items={attachmentItems()}
            handleButtonClick={handleAttachmentButtonClick}
          />
        </MDBox>
        <OrderHeader
          color="info"
          fields={formFields.footerFields}
          data={renderFooterValues()}
        />
        <MDBox
          display="flex"
          justifyContent="center"
          alignItems="center"
          mt={4}
          mb={2}
        >
          <MDButton
            variant="contained"
            color="info"
            size="medium"
            onClick={() => navigate("/pedidos")}
            sx={{ mr: 2 }}
          >
            Voltar
          </MDButton>
          <MDButton
            variant="contained"
            color="success"
            size="medium"
            onClick={handleUpdate}
            disabled={order.Status === "C" || order.Status === "R"}
          >
            Atualizar
          </MDButton>
        </MDBox>
        {snackBar}
      </MDBox>

      <Modal open={modalOpen} onClose={handleModalClose}>
        <MDBox
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: '80%',
            maxWidth: 1200,
            bgcolor: "background.paper",
            boxShadow: 24,
            p: 4,
            borderRadius: 4,
            maxHeight: "90vh",
            display: "flex",
            flexDirection: "column",
          }}
        >
          <MDButton
            onClick={handleModalClose}
            sx={{
              position: "absolute",
              top: 16,
              right: 16,
              color: "text.secondary",
              backgroundColor: "transparent",
              "&:hover": {
                backgroundColor: "#f0f0f0",
              },
              width: 40,
              height: 40,
            }}
          >
            <CloseIcon />
          </MDButton>
          <MDTypography
            variant="h6"
            fontWeight="medium"
            color="text.primary"
            gutterBottom
            sx={{ textAlign: "center" }} // Centraliza o texto
          >
            {selectedItemTax.ItemCode} - {selectedItemTax.ItemName}
          </MDTypography>

          <MDBox sx={{ flex: 1, overflowY: "auto", mt: 2 }}>
            <DataTable
              table={{
                columns: taxModalFields.columns,
                rows: selectedTaxItems,
              }}
              isSorted={false}
              entriesPerPage={false}
              showTotalEntries={false}
              noEndBorder
              sx={{
                "& .MuiTableCell-root": {
                  padding: "16px 8px",
                },
              }}
            />
          </MDBox>

          <MDBox sx={{ display: 'flex', justifyContent: 'center', mt: 2 }}>
            <MDButton
              onClick={handleModalClose}
              variant="contained"
              color="success"
              size="medium"
            >
              OK
            </MDButton>
          </MDBox>
        </MDBox>
      </Modal>
      <Snackbar
        open={snackbar.open}
        autoHideDuration={3000}
        onClose={handleCloseSnackbar}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
      >
        <Alert
          onClose={handleCloseSnackbar}
          severity={snackbar.severity}
          sx={{ width: "100%" }}
        >
          {snackbar.message}
        </Alert>
      </Snackbar>
    </>
  );
};

export default OrderDetails;


